<div>
    <div class="upload-container m-4 p-4">
    <input type="file" (change)="onFileSelected($event)" />
    <br/>
    <br/>
    <button (click)="onUpload()" *ngIf="selectedFile" [disabled]="!selectedFile">Upload</button>
    <br/><br/>
    <div class="pt-4" *ngIf="progress > 0 ">
    <p>Progress: {{ progress }}%</p>
    <progress [value]="progress" max="100"></progress>
    </div>
    <br/><br/>
    <p *ngIf="message">{{ message }}</p>
    </div>
</div>